import React from 'react'
import GallerySection from './Inc/GallerySection'
import { MetaTags } from "react-meta-tags";


export default function Gallery() {
  return (
    <>
      <MetaTags>
        <title>All Type Of Towing Services | Modern Towing </title>
        <meta title="All Type Of Towing Services | Modern Towing" />
        <meta name="description" content="Towing Services Mumbai, Car Towing Services in Andheri, Top Car Towing Services in Andheri West, Flatbed Towing Service in Andheri, Best Hydraulic Towing in Andheri, Two Wheeler Towing Services in Andheri, Top Car Towing Services For Luxury Car in Andheri, Truck Towing Services in Andheri, All Type Of Towing Services, Towing Services near Andheri " />
        <link rel="canonical" href="https://moderntowing.in/all-types-of-towing-services" />
        <meta http-equiv="cache-control" content="no-cache" />
        <meta http-equiv="expires" content="0" />
        <meta http-equiv="pragma" content="no-cache" />
        <meta property="og:title" content="All Type Of Towing Services | Modern Towing" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://moderntowing.in/" />
        <meta property="og:description" content="Looking for All Types Of Towing Services? We offer flatbed, hydraulic, and emergency towing solutions 24/7. Get reliable and professional assistance." />
        <meta property="og:image" content="https://kinararesort.in/static/media/logo.146c55d2a549f20e2963.png" />
      </MetaTags>
      <section className="page_breadcrumbs cs background_cover section_padding_top_40 section_padding_bottom_40">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 text-center custom-contact-col">
              <h2>Gallery</h2>
              <ol className="breadcrumb">
                <li>
                  <a href="./">Home</a>
                </li>
                <li className="active">Gallery</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <GallerySection />
    </>
  )
}
